import { useLocation } from 'react-router-dom';
import { toByteArray } from 'base64-js';
import queryString from 'query-string';

export function decodeBase64(str) {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
  const bytes = toByteArray(padded);
  return new TextDecoder('utf-8').decode(bytes);
}

const useQueryString = () => {
  const { search } = useLocation();
  const query = queryString.parse(search, { decode: false });

  const decodeId = decodeBase64(query.id || '');
  const parsed = queryString.parse(decodeId);

  return {
    sessionId: parsed.sessionId || '',
    expiredDate: parsed.expiredDate || '',
    mode: parsed.mode || '',
    collaboCategory: parsed.collaboCategory || '',
    collaboName: parsed.collaboName || '',
    countryCode: parsed.countryCode || '',
  };
};

export default useQueryString;
